import BankAccount from '@/components/bank-account/index';

export default BankAccount;
